<!--  -->
<template>
  <div v-loading="loading">
    <div class="onebox">
      <div>标题：</div>
      <el-input v-model.trim="title" placeholder="请输入标题" style="width:300px" />
    </div>
    <div class="onebox" style="margin:10px 0px">
      <div>内容：</div>
      <el-input v-model.trim="content" placeholder="请输入内消息文本内容" style="width:300px" />
    </div>
    <div class="onebox">
      <div class="all_box">
        <div v-for="item,index in attachments" :key="index" style="margin: 10px 0px;">
          <div class="search_box">
            附件{{ index+1 }}:
            <el-radio-group v-model="item.msgtype" size="small" @change="dialogtype(item.msgtype,index)">
              <el-radio-button :label="'image'">图片</el-radio-button>
              <el-radio-button :label="'link'">图文</el-radio-button>
              <el-radio-button :label="'miniprogram'">小程序</el-radio-button>
            </el-radio-group>
            <el-button type="warning" style="margin-left:10px" size="small" icon="el-icon-edit-outline" @click="dialogtyper(item.msgtype,index)">编辑附件</el-button>
            <el-button v-if="attachments.length>1" type="danger" style="margin-left:10px" icon="el-icon-delete" size="small" @click="deleter(index)">删除附件</el-button>
            <el-button v-if="attachments.length!==9 && index === 0" type="success" icon="el-icon-plus" style="margin-left:10px" size="small" @click="add(item)">添加附件</el-button>
          </div>
          <div v-if="item.msgtype === 'image'">
            <img v-if="item.msgtype === 'image' && item.image && item.image.source_material_id!=='' && item.image.source_material_id!==null" :src="item.image.pic_url" style="width:80px;height:80px;margin:10px 0px 0px 44px">
          </div>
          <div v-if="item.msgtype === 'link'">
            <div v-if="item.msgtype === 'link' && item.link && item.link.title!==''&& item.link.title!==null" class="within_box">
              <div class="title_boxr">{{ item.link.title }}</div>
              <div class="imaetext se_top">
                <div class="describe_text">{{ item.link.desc }}</div>
                <div>
                  <img v-if="item.link.picurl" style="width:50px;height:50px;object-fit: contain;" :src="item.link.picurl">
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.msgtype === 'miniprogram'">
            <div v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.title!=='' && item.miniprogram.title!==null">
              <div class="mincard">
                <div class="mincard_title">{{ find(item.miniprogram.appid) }}</div>
                <div class="mincard_enjoy">{{ item.miniprogram.title }}</div>
                <div>
                  <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.pic_media_src!=='' && item.miniprogram.pic_media_src!==null" :src="item.miniprogram.pic_media_src" class="imgrbox">
                </div>
                <div class="line" />
                <div class="bottomwr">
                  <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                  <div class="weadar">小程序</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div><el-button type="primary" @click="onclick">确定</el-button></div>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 图文弹窗 -->
    <el-dialog
      title="选择图文"
      :visible.sync="dialogVisibletu"
      append-to-body
      :destroy-on-close="true"
    >
      <edittuwen ref="tuwenview" @callback="callback" />
    </el-dialog>
    <!-- 小程序弹窗 -->
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisiblewechat"
      append-to-body
      :destroy-on-close="true"
    >
      <wecaht ref="wecahtview" @callwechat="callwechat" />
    </el-dialog>

  </div>
</template>

<script>
import chooseimg from '../../menumanagement/components/chooseimg.vue'
import { spMessage, spMessagelistupdata, sprEnterprise } from '@/api/officialaccount.js'
import { mptypeslist } from '@/api/sourceMaterial.js'
import edittuwen from './edittuwen.vue'
import wecaht from './wecaht.vue'
export default {
  components: { chooseimg, edittuwen, wecaht },
  data() {
    return {
      content: '', // 内容
      title: '', // 标题
      attachments: [{ // 数据数组
        msgtype: ''
        // image: {
        //   source_material_id: '',
        //   pic_url: ''
        // }
        //   "link": {
        // 	"title": "消息标题",
        // 	"picurl": "https://example.pic.com/path",
        // 	"desc": "消息描述",
        // 	"url": "https://example.link.com/path"
        // }
      }],
      dialogVisibletwo: false, // 图片库弹窗
      dialogVisibletu: false, // 图文的弹窗
      dialogVisiblewechat: false, // 小程序的弹窗
      activetype: '', // 类型
      activeindex: null, // 选择的索引
      type: null, // 新增还是编辑类型
      sp_message_no: null, // 编辑的id
      programtype: [], // 小程序类型
      attachmentsarrs: [], // 数据数组(要传的)
      ids: null,
      loading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    dialogtype(type, index) {
      if (type === 'image') {
        if (this.attachments[index].image) {
          console.log('有image')
        } else {
          this.attachments[index].image = {}
          this.attachments[index].image.source_material_id = ''
          this.attachments[index].image.pic_url = ''
        // delete this.attachments[index].link
        // delete this.attachments[index].miniprogram
        }
      } else if (type === 'link') {
        if (this.attachments[index].link) {
          console.log('有link')
        } else {
          this.attachments[index].link = {}
          this.attachments[index].link.title = ''
          this.attachments[index].link.picurl = ''
          this.attachments[index].link.source_material_id = ''
          this.attachments[index].link.desc = ''
          this.attachments[index].link.url = ''
        // delete this.attachments[index].image
        // delete this.attachments[index].miniprogram
        }
      } else {
        if (this.attachments[index].miniprogram) {
          console.log('有miniprogram')
        } else {
          this.attachments[index].miniprogram = {}
          this.attachments[index].miniprogram.title = ''
          this.attachments[index].miniprogram.source_material_id = ''
          this.attachments[index].miniprogram.appid = ''
          this.attachments[index].miniprogram.page = ''
          this.attachments[index].miniprogram.pic_media_src = ''
        // delete this.attachments[index].image
        // delete this.attachments[index].link
        }
      }
    },
    dialogtyper(type, index) {
      if (type === '') {
        this.$message.error('请选择要编辑的类型')
        return
      }
      if (type === null) {
        this.$message.error('请选择要编辑的类型')
        return
      }
      console.log('type', type)
      this.activetype = type
      this.activeindex = index
      if (type === 'image') {
        this.dialogVisibletwo = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
      } else if (type === 'link') {
        console.log(this.attachments[index].link.title)
        this.dialogVisibletu = true
        if (this.attachments[index].link.title === '') {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send({})
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send(this.attachments[index].link)
          }, 100)
        }
      } else {
        this.dialogVisiblewechat = true
        if (this.attachments[index].miniprogram.title === '') {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.wecahtview.send({})
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.wecahtview.send(this.attachments[index].miniprogram)
          }, 100)
        }
      }
    },
    add() {
      this.attachments.push({
        msgtype: ''
      })
    },
    deleter(index) {
      this.attachments.splice(index, 1)
    },
    async onclick() {
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.content === '') {
        this.$message.error('请输入内消息文本内容')
        return
      }
      const msgtypebool = this.attachments.every((item, index, array) => {
        return item.msgtype
      })
      if (msgtypebool === false) {
        this.$message.error('请选择类型')
        return
      }
      const arrs = []
      this.attachments.forEach((item) => {
        if (item.msgtype === 'miniprogram') {
          arrs.push({
            appid: item.miniprogram.appid,
            page: item.miniprogram.page,
            pic_media_src: item.miniprogram.pic_media_src,
            source_material_id: item.miniprogram.source_material_id,
            title: item.miniprogram.title
          })
        }
      })
      const routinetypebool = arrs.every((item, index, array) => {
        return item.appid !== ''
      })
      if (routinetypebool === false) {
        this.$message.error('请完善要编辑的小程序附件')
        return
      }
      const arrsr = []
      this.attachments.forEach((item) => {
        if (item.msgtype === 'link') {
          arrsr.push({
            title: item.link.title,
            url: item.link.url,
            source_material_id: item.link.source_material_id,
            picurl: item.link.picurl,
            desc: item.link.desc
          })
        }
      })
      const imagetypebool = arrsr.every((item, index, array) => {
        return item.title !== ''
      })
      if (imagetypebool === false) {
        this.$message.error('请完善要编辑的图文附件')
        return
      }

      const imagearr = []
      this.attachments.forEach((item) => {
        if (item.msgtype === 'image') {
          imagearr.push({
            pic_url: item.image.pic_url,
            source_material_id: item.image.source_material_id
          })
        }
      })
      const imgtypebool = imagearr.every((item, index, array) => {
        return item.pic_url !== ''
      })
      if (imgtypebool === false) {
        this.$message.error('请完善要编辑的图片附件')
        return
      }
      console.log(' this.attachments', this.attachments)
      this.attachmentsarrs = []
      this.attachments.forEach((item, index) => {
        if (item.msgtype === 'miniprogram') {
          this.attachmentsarrs.push({
            msgtype: 'miniprogram',
            miniprogram: item.miniprogram
          })
        }
        if (item.msgtype === 'link') {
          this.attachmentsarrs.push({
            msgtype: 'link',
            link: item.link
          })
        }
        if (item.msgtype === 'image') {
          this.attachmentsarrs.push({
            msgtype: 'image',
            image: item.image
          })
        }
      })
      if (this.type === 1) {
        const data = await spMessage({
          title: this.title,
          content: this.content,
          attachments: this.attachmentsarrs
        })
        this.$emit('updata')
        console.log('data', data)
      } else {
        const data = await spMessagelistupdata({
          title: this.title,
          content: this.content,
          attachments: this.attachmentsarrs,
          sp_message_no: this.sp_message_no
        })
        this.$emit('updata')
        console.log('data', data)
      }
    },
    clickicon(img, key) {
      if (this.activetype === 'image') {
        this.dialogVisibletwo = false
        this.attachments[this.activeindex].image.source_material_id = key
        this.attachments[this.activeindex].image.pic_url = img
      }
    },
    callback(form) {
      if (this.activetype === 'link') {
        this.dialogVisibletu = false
        this.attachments[this.activeindex].link.title = form.title
        this.attachments[this.activeindex].link.picurl = form.testsrc
        this.attachments[this.activeindex].link.source_material_id = form.source_material_id
        this.attachments[this.activeindex].link.desc = form.description
        this.attachments[this.activeindex].link.url = form.url
      }
    },
    callwechat(form) {
      if (this.activetype === 'miniprogram') {
        this.dialogVisiblewechat = false
        console.log('form', form)
        this.attachments[this.activeindex].miniprogram.title = form.name
        this.attachments[this.activeindex].miniprogram.source_material_id = form.sourceMaterialId
        this.attachments[this.activeindex].miniprogram.appid = form.appid
        this.attachments[this.activeindex].miniprogram.page = form.link
        this.attachments[this.activeindex].miniprogram.pic_media_src = form.programimg
      }
    },
    opens(type, item) {
      this.getmptypeslist()
      this.type = type
      if (type === 1) {
        console.log('新增')
        // this.attachments = item.attachments
      } else {
        console.log(item)
        this.ids = item.sp_message_no
        this.detail()
      }
    },
    async detail() {
      this.loading = true
      const data = await sprEnterprise({
        sp_message_no: this.ids
      })
      this.attachments = []
      this.title = data.data.title
      this.content = data.data.content
      this.attachments = data.data.attachments
      this.sp_message_no = data.data.sp_message_no
      this.loading = false
      console.log('data', data)
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box{
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 44px;
  margin-top: 15px;
}
.title_boxr{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 157px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard{
  width: 150px;
  height: 190px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 44px;
}
.mincard_title{
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox{
  width: 100%;
  height: 100px;
}
.line{
  width: 100%;
  height: 1px;
  background: #999999;
  margin: 5px 0px;
}
.bottomwr{
  display: flex;
  align-items: center;
}
.mincard_enjoy{
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar{
  margin-left: 2px;
  font-size: 12px;
}
.all_box{
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox{
  display: flex;
  align-items: center;
}
</style>
